import { forwardRef } from '@angular/core';

// CDK
import { IOption } from '@cdk/pgs-select-search';

import { Type } from 'class-transformer';

import { BaseModel } from '../../shared/models/base.model';


export class StoreModel extends BaseModel {

  identificationNumber: string;
  name: string;
  address: string;
  brandId: string;
  brandName: any;

  toIOption(): IStore {
    return {
      value: this.identificationNumber,
      label: `${this.identificationNumber} - ${this.name}`,
      store: this,
    };
  }
}

export class StoresModel {
  country: string;
  @Type(forwardRef(() => StoreModel) as any)
  lstStores: StoreModel[];
}

export interface IStore extends IOption {
  store: StoreModel;
}
